import { render } from "./DeliveryEstimator.vue?vue&type=template&id=422604e6&scoped=true"
import script from "./DeliveryEstimator.vue?vue&type=script&lang=js"
export * from "./DeliveryEstimator.vue?vue&type=script&lang=js"

import "./DeliveryEstimator.vue?vue&type=style&index=0&id=422604e6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422604e6"]])

export default __exports__